/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ILensPrescription } from 'app/shared/model/lens-prescription.model';
import { IEye } from 'app/shared/model/eye.model';
import { VisionProductType } from 'app/shared/model/enumerations/vision-product-type.model';
import { EyeSide } from 'app/shared/model/enumerations/eye-side.model';
import { PrismVisualBase } from 'app/shared/model/enumerations/prism-visual-base.model';
import { EyeReadingType } from 'app/shared/model/enumerations/eye-reading-type.model';

export interface ILensSpecification {
  id?: string;
  issuedDate?: number | null;
  active?: boolean;
  timestampEntry?: number;
  microSec?: number;
  lastUpdated?: number;
  cursor?: number;
  visionProductType?: keyof typeof VisionProductType | null;
  eyeSide?: keyof typeof EyeSide | null;
  sphere?: number | null;
  cylinder?: number | null;
  axis?: number | null;
  prismAmount?: number | null;
  prismBase?: keyof typeof PrismVisualBase | null;
  mlPower?: number | null;
  clPower?: number | null;
  clBackCurve?: number | null;
  clDiameter?: number | null;
  wearingDuration?: number | null;
  color?: string | null;
  brand?: string | null;
  notes?: string | null;
  eyeReadingType?: keyof typeof EyeReadingType | null;
  prescription?: ILensPrescription | null;
  eye?: IEye | null;
}

export const defaultValue: Readonly<ILensSpecification> = {
  active: false,
};
